import * as React from "react";
import { Link } from "react-router-dom";

// Components
import LogoDW from "../LogoDW/LogoDW";

// Style
import "./Header.scss";
import NavLink from "../NavLink/NavLink";

// Misc.
import Topic from "../../types/Topic.interface";

interface Header {
  navData: Topic[];
}

const Header: React.FC<Header> = (props: Header) => {
  const { navData } = props;
  const [open, setOpen] = React.useState(false);

  const toggleOpen = () => setOpen(!open);

  React.useEffect(() => {
    if (open) {
      document.body.classList.add("overflow-hidden", "h-screen");
    } else {
      document.body.classList.remove("overflow-hidden");
    }
  }, [open]);

  return (
    <header
      className={`main-header fixed top-0 left-0 right-0 py-2 text-dw-blue z-20 ${
        open ? "--active" : ""
      }`}
    >
      <div className="w-11/12 mx-auto relative">
        <div className="main-header__container flex flex-col justify-between">
          <LogoDW />
          <div className="flex items-center justify-between">
            <Link
              to="/categories"
              className="main-header__textlogo font-serif text-l font-semibold"
              onClick={() => {
                if (open) toggleOpen();
              }}
            >
              <p className="inline text-dw-blue">Threat </p>
              <p className="inline text-white">Check</p>
            </Link>
            <button
              className={`hamburger hamburger--collapse ${
                open ? "is-active" : ""
              }`}
              type="button"
              onClick={toggleOpen}
            >
              <span className="hamburger-box">
                <span className="hamburger-inner" />
              </span>
            </button>
          </div>
        </div>
        <div className="main-header__navigation">
          <hr className="opacity-25 my-3" />
          <nav className="mx-auto pb-3 max-w-screen-xl">
            <NavLink to="/continue" closeMenu={toggleOpen} isOpen={open}>
              Continue Policy
            </NavLink>

            <NavLink to="/faq/usage" closeMenu={toggleOpen} isOpen={open}>
              FAQ
            </NavLink>
            <div className="pl-3 md:grid md:grid-cols-2 xl:grid-cols-3">
              <NavLink to="/faq/usage" closeMenu={toggleOpen} isOpen={open}>
                How Do I Use Threat Check?
              </NavLink>
              <NavLink to="/faq/security" closeMenu={toggleOpen} isOpen={open}>
                How Secure Is Threat Check?
              </NavLink>
            </div>

            <NavLink to="/categories" closeMenu={toggleOpen} isOpen={open}>
              Topic Overview
            </NavLink>
            <div className="pl-3 md:grid md:grid-cols-2 xl:grid-cols-3">
              {navData &&
                navData.map((topic) => {
                  return (
                    <NavLink
                      key={topic._id}
                      to={`/category/${topic._id}`}
                      closeMenu={toggleOpen}
                      isOpen={open}
                    >
                      {topic.title}
                    </NavLink>
                  );
                })}
            </div>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
